import { render, staticRenderFns } from "./MapBulkOrders.vue?vue&type=template&id=dbcb7d5c&scoped=true"
import script from "./MapBulkOrders.vue?vue&type=script&lang=js"
export * from "./MapBulkOrders.vue?vue&type=script&lang=js"
import style0 from "./MapBulkOrders.vue?vue&type=style&index=0&id=dbcb7d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcb7d5c",
  null
  
)

export default component.exports